import styled from 'styled-components';

export const MetricsPage = styled.div`
  .w-100,
  .row {
    .col-12 {
      display: flex;
    }
  }

  .MuiFormControlLabel-root {
    border: none;
    padding: 0 16px 0 0;

    &:focus-within {
      border: none;
      box-shadow: none;
    }
  }
`;
